const AVAILABLE_LOCALES = environment_config.available_locales;

const NO_SVG_SUPPORT_COUNTRY_CODES = ['xk'];

export {
    AVAILABLE_LOCALES,
    NO_SVG_SUPPORT_COUNTRY_CODES,
};
